<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	
	
	<AuthForm :title="$t('general.forgotPassword')"
	          :button-label="$t('general.sendEmail')"
	          @submit="forgotPassword">
		<template v-slot:formFields>
			<v-col cols="12">
				<v-text-field
						class="custom_textfield"
						v-model="user.email"
						:error-messages="emailErrors"
						:label="$t('general.email')"
						:clearable=true
						name="email"
						prepend-inner-icon="person"
						type="text"
						@input="$v.user.email.$touch()"
						@blur="$v.user.email.$touch()"
						outlined
				></v-text-field>
			</v-col>
		</template>
	</AuthForm>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, email, alphaNum} from 'vuelidate/lib/validators'
    import AuthForm from '../components/AuthForm.vue'


    export default {
        mixins: [validationMixin],
        components: {
            AuthForm
        },
        props: {
            source: String,
        },
        validations: {
            user: {
                email: {
                    required,
                    email
                }
            }
        },
        data: () => ({
            drawer: null,
            user: {
                email: '',
                password: ''
            }
        }),
        computed: {
            emailErrors() {
                const errors = [];
                if (!this.$v.user.email.$dirty) return errors;
                !this.$v.user.email.required && errors.push(this.$t('validation.required'));
                !this.$v.user.email.email && errors.push(this.$t('validation.email'));
                return errors;
            },
        },
        methods: {
            forgotPassword() {
                // Check if form input is valid.
                this.$v.user.$touch();
                if (!this.$v.user.$invalid) {
					
                    // send request to server
                    axios.post(`${this.$store.state.api_url}/api/forgot-password`, this.user)
                        .then(response => {
                            this.$store.dispatch('showResponseNotification', {"response": response, "timeout": 3000});
                            this.$router.push('/login');
                        })
                        .catch(error => {
                            this.$store.dispatch('showResponseNotification', {
                                "response": error.response, "timeout": 5000
                            });
                        })
                }
            },
        }
    }
</script>